import React from 'react';

import { Modal, Button } from '@weezevent/nacre';
import useAppContext from '../../../../context/useAppContext';
import { useTranslation } from 'react-i18next';

export function OrganizationMustBeConfirmedModal({ open = false, onSave = () => {}, onClose = () => {}, createMode = false }) {
    const { t } = useTranslation();
    let [{ organization }] = useAppContext();

    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            onClose={onClose}
            cancelButton={createMode ? <Button onClick={onSave} label={t(`ticket.event.organizationMustBeConfirmedModal.saveLabel`)} /> : null}
            title={t('ticket.event.organizationMustBeConfirmedModal.title')}
        >
            <div style={{ marginTop: '15px' }}>{t('ticket.event.organizationMustBeConfirmedModal.description', { orga_mail: organization.email || '' })}</div>
            {createMode && <div style={{ marginTop: '15px' }}>{t('ticket.event.organizationMustBeConfirmedModal.descriptionSave', { orga_mail: organization.email || '' })}</div>}
        </Modal>
    );
}
